















import {Component, Prop, Vue} from "vue-property-decorator";
import {SiteStore} from "@/modules/sites/store";
import {Site} from "@/interfaces/entity";

@Component({
    name: "SiteTableAction"
})
export default class extends Vue {
    @Prop({ required: true, type: Number })
    readonly siteId!: number;

    get site(): Site {
        return SiteStore.data[this.siteId];
    }

    set site(value: Site) {
        SiteStore.data[this.siteId] = value;
    }
    async onConfirm() {
        try {
            await SiteStore.deleteSite(this.siteId);
            this.$notification.success({
                message: "Thành công",
                description: "Xóa địa danh thành công"
            });
        } catch (e) {
            console.log(e);
            this.$notification.error({
                message: "Thất bại",
                description: "Xóa địa danh thất bại"
            });
        }
    }
}
